import loadable from '@react-loadable/revised';
import Footer from 'components/Footer';
import Layout from 'components/Layout';
import LegendBox from 'components/pages/financing-for-companies/items/LegendBox';
import SourcesBox from 'components/pages/financing-for-companies/items/SourcesBox';
import CardView from 'components/pages/financing-for-companies/view/CardView';
import CheckClientView from 'components/pages/financing-for-companies/view/CheckClientView';
import HowItWorkDesktopView from 'components/pages/financing-for-companies/view/HowItWorkDesktopView';
import HowItWorkMobileView from 'components/pages/financing-for-companies/view/HowItWorkMobileView';
import InstrumentsView from 'components/pages/financing-for-companies/view/InstrumentsView';
import { StaticImage } from 'gatsby-plugin-image';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import useSearchParams, { getSearchParam } from 'hooks/useSearchParams';
import React, { useEffect, useRef } from 'react';
import useInView from 'react-cool-inview';
import { scrollInto } from 'utils/helper';

const LazyLoadIndex = loadable({
	loader: () => import('components/pages/supply-chain-financing/view/LazyLoadIndex'),
	loading: () => <div />
});

export default function FinancingCompanyPage() {
	const { observe, unobserve, inView } = useInView({});
	const { location, searchLangParams } = useSearchParams();
	const { t } = useTranslation();
	const refWhoIsAnimator = useRef();

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	useEffect(() => {
		if(inView) {
			unobserve();
		}
	}, [inView]);

	useEffect(() => {
		if(
			getSearchParam(location.search) === searchLangParams.section.contactForm ||
			getSearchParam(location.search) === searchLangParams.section.calculatorSection
		) {
			scrollInto(refWhoIsAnimator);
		}
	}, []);

	return (
		<Layout>
			<div className='mb-40'>
				{/* financing company */}
				<div className='sm:flex sm:items-center xl:items-start justify-end'>
					<div className='w-full sm:w-80/100 xl:w-50/100 mt-10 sm:ml-30'>
						<div className='layout sm:mr-20'>
							<h1 className='sm:text-shadow pt-40 sm:pt-60 lg:pt-80 xl:pt-120'>{t('pageFinancingForCompany.h1')}<span className='text-green-1 font-normal text-shadow-none'>_</span></h1>
							<p className='my-15'>{t('pageFinancingForCompany.desc')}</p>
						</div>
					</div>

					<div className='hidden sm:block xl:mt-60'>
						<StaticImage src='../../../assets/secure-financing/secure-financing.png' alt="" placeholder='none' />
					</div>

					<div className='sm:hidden w-full my-15'>
						<StaticImage src='../../../assets/secure-financing/secure-financing-mobile.png' alt="" placeholder='none' />
					</div>
				</div>

				{/* why Finteq */}
				<div className='layout'>
					<h2 className="text-center leading-20 w-80/100 sm:w-60/100 mx-auto mb-45 pt-40 xl:pt-90">{t('pageFinancingForCompany.whyFinteq.h2')}<span className="text-green-1 font-normal text-shadow-none">_</span></h2>
					<CardView />
				</div>

				{/* sources */}
				<div className='layout'>
					<h2 className="pt-20 sm:pt-50">{t('pageFinancingForCompany.sources.h2')}<span className="text-green-1 font-normal text-shadow-none">_</span></h2>
					<SourcesBox />
				</div>

				{/* instruments */}
				<InstrumentsView />

				{/* legend */}
				<div className='layout'>
					<h2 className="pt-40 xl:pt-90">{t('pageFinancingForCompany.legend.h2')}<span className="text-green-1 font-normal text-shadow-none">_</span></h2>
					<LegendBox />
				</div>

				{/* how it work */}
				<div>
					<h2 className="text-center leading-20 mx-auto mb-30 sm:mb-45 pt-30 xl:pt-50">{t('pageFinancingForCompany.howItWork.h2')}<span className="text-green-1 font-normal text-shadow-none">_</span></h2>
					<div className='hidden sm:block'>
						<HowItWorkDesktopView />
					</div>
					<div className='sm:hidden mb-40'>
						<HowItWorkMobileView />
					</div>
				</div>

				{/* how to start */}
				<div className='layout'>
					<h2 className="text-center leading-20 mx-auto mb-35 sm:mb-45">{t('pageFinancingForCompany.howToStart.h2')}<span className="text-green-1 font-normal text-shadow-none">_</span></h2>
					<CheckClientView />
				</div>

				{/*<SeoLazy*/}
				{/*	isOpen={!inView}*/}
				{/*	items={[*/}
				{/*		{ id: 1, tag: 'h2', text: t('pageAnimator.benefitsAsAnimator.h2') },*/}
				{/*		{ id: 2, tag: 'p', text: t('pageAnimator.benefitsAsAnimator.desc.1') },*/}
				{/*		{ id: 3, tag: 'p', text: t('pageAnimator.benefitsAsAnimator.desc.2') },*/}
				{/*		{ id: 4, tag: 'p', text: t('pageAnimator.benefitsAsAnimator.bold') },*/}
				{/*		{ id: 5, tag: 'h2', text: t('pageAnimator.calculator.h2') },*/}
				{/*		{ id: 6, tag: 'p', text: t('pageAnimator.calculator.desc') },*/}
				{/*		{ id: 7, tag: 'p', text: t('pageAnimator.calculator.bold') },*/}
				{/*		{ id: 8, tag: 'h2', text: t('pageAnimator.benefitsAsSupplier.h2') },*/}
				{/*		{ id: 9, tag: 'p', text: t('pageAnimator.benefitsAsSupplier.desc') },*/}
				{/*		{ id: 10, tag: 'h2', text: t('pageAnimator.benefitsAsSupplierList.h2') },*/}
				{/*		{ id: 11, tag: 'h3', text: t('pageAnimator.benefitsAsSupplierList.ul.li.1') },*/}
				{/*		{ id: 12, tag: 'h3', text: t('pageAnimator.benefitsAsSupplierList.ul.li.2') },*/}
				{/*		{ id: 13, tag: 'h3', text: t('pageAnimator.benefitsAsSupplierList.ul.li.3') },*/}
				{/*		{ id: 14, tag: 'h3', text: t('pageAnimator.benefitsAsSupplierList.ul.li.4') },*/}
				{/*		{ id: 15, tag: 'h3', text: t('pageAnimator.benefitsAsSupplierList.ul.li.5') },*/}
				{/*		{ id: 16, tag: 'h3', text: t('pageAnimator.benefitsAsSupplierList.ul.li.6') },*/}
				{/*		{ id: 17, tag: 'h3', text: t('pageAnimator.benefitsAsSupplierList.ul.li.7') },*/}
				{/*		{ id: 18, tag: 'h3', text: t('pageAnimator.benefitsAsSupplierList.ul.li.8') },*/}
				{/*		{ id: 19, tag: 'h2', text: t('pageAnimator.howToStart.h2') },*/}
				{/*		{ id: 20, tag: 'p', text: t('pageAnimator.howToStart.desc') },*/}
				{/*	]}*/}
				{/*/>*/}
			</div>

			{/*{inView && <LazyLoadIndex />}*/}
			<div className='relative'>
				<div className='hidden lg:block absolute bottom-0 right-0 -z-10'>
					<StaticImage src='../../../assets/secure-financing/bg-footer.png' alt="" />
				</div>
			</div>

			<Footer />
		</Layout>
	);
}
